// tslint:disable:component-selector
// tslint:disable:max-line-length
import { Component, ViewChild, Type, ComponentFactoryResolver, ChangeDetectorRef, AfterViewInit, ComponentRef, ViewEncapsulation, OnDestroy } from '@angular/core';
import { MaxDialogDirective } from './directives/max-dialog.directive';
import { fromEvent } from 'rxjs';
import { filter } from 'rxjs/operators';
import { MaxDialogRef } from './models/max-dialog-ref';
import { first } from 'rxjs/operators';

@Component({
    selector: 'max-dialog',
    templateUrl: './max-dialog.component.html',
    styleUrls: ['./max-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class MaxDialogComponent implements AfterViewInit, OnDestroy {
    @ViewChild(MaxDialogDirective) insertionPoint: MaxDialogDirective;
    componentRef: ComponentRef<any>;
    childComponentType: Type<any>;
    show: boolean;

    constructor(private componentFactoryResolver: ComponentFactoryResolver, private cd: ChangeDetectorRef, private dialogRef: MaxDialogRef) {
        this.disableScroll();
        setTimeout(() => { this.show = true; }, 0);
    }

    ngAfterViewInit(): void {
        const viewContainerRef = this.insertionPoint.viewContainerRef;
        viewContainerRef.clear();
        this.componentRef = viewContainerRef.createComponent(this.componentFactoryResolver.resolveComponentFactory(this.childComponentType));
        this.cd.detectChanges();
        fromEvent(document, 'keydown').pipe(filter((e: KeyboardEvent) => e.key === 'Escape'), first()).subscribe(() => {
            this.close();
        });
    }

    ngOnDestroy(): void {
        const html = document.getElementsByTagName('html')[0];
        html.classList.remove('dialog-scrollblock');
        window.scrollTo(Math.abs(Number(html.style.left.slice(0, -2))), Math.abs(Number(html.style.top.slice(0, -2))));
        html.style.top = ``;
        html.style.left = ``;
    }

    close(): void {
        this.show = false;
        setTimeout(() => { this.dialogRef.close(); }, 400);
    }

    private disableScroll(): void {
        const html = document.getElementsByTagName('html')[0];
        html.style.top = `-${window.scrollY}px`;
        html.style.left = `-${window.scrollX}px`;
        html.classList.add('dialog-scrollblock');
    }
}
